import { render, staticRenderFns } from "./PreferencesView.vue?vue&type=template&id=5a65503c&"
import script from "./PreferencesView.vue?vue&type=script&lang=js&"
export * from "./PreferencesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports